export default "__VITE_ASSET__CSXxJ1Kg__"